import { TOKEN_KEY } from "../config";

const COUNT_ABBRS = ["", "K", "M", "G", "T", "P", "E", "Z", "Y"];
export const formatCount = (count, withAbbr = false, decimals = 2) => {
  const i = 0 === count ? count : Math.floor(Math.log(count) / Math.log(1000));
  let result = parseFloat((count / Math.pow(1000, i)).toFixed(decimals));
  if (withAbbr) {
    result += `${COUNT_ABBRS[i]}`;
  }
  return result;
};

export const formatDate = (unixTimeStamp) => {
  const date = new Date(unixTimeStamp * 1000);
  if (!date) return;
  const formatedDate = `${date.getDate()}/${
    date.getMonth() + 1
  }/${date.getFullYear()}`;
  return formatedDate;
};

export const formatDateWithHyphens = (date) => {
  if (!date) return;
  const formatedDate = `${date.getDate()}-${
    date.getMonth() + 1
  }-${date.getFullYear()}`;
  return formatedDate;
};

export const generateURL = (obj) => {
  // Initialize an array to hold key-value pairs
  const keyValuePairs = [];

  // Loop through the object's properties
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      // Encode the key and value and add them to the array
      const encodedKey = encodeURIComponent(key);
      const encodedValue = encodeURIComponent(obj[key]);
      keyValuePairs.push(`${encodedKey}=${encodedValue}`);
    }
  }

  // Join the key-value pairs with "&" and add them to the base URL
  const queryString = keyValuePairs.join("&");
  const url = `?${queryString}`;

  return url;
};

export const getToken = () => {
  return sessionStorage.getItem(TOKEN_KEY);
};

export const generateSlug = (input) => {
  return input
    .trim() // Remove leading and trailing whitespaces
    .toLowerCase() // Convert to lowercase
    .replace(/\s+/g, "-") // Replace spaces with hyphens
    .replace(/[^a-zA-Z0-9\-]/g, ""); // Remove non-alphanumeric characters except hyphens
};

export const convertToSentenceCase = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const timestampToYYYYMMDD = (timestamp) => {
  const date = new Date(parseFloat(timestamp) * 1000);
  if (!date) return;

  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const formattedDate = `${date.getFullYear()}-${month}-${day}`;

  return formattedDate;
};

export const checkIfEmpty = (value) => {
  return value === null || value === undefined || value === "";
};

export const checkIfNotEmpty = (value) => {
  return (
    value !== null && value !== undefined && value !== "" && value !== "null"
  );
};

// ------ Number input validation functions ------
// Function for number input keydown event
export const onNumberKeydown = (e, { isPositiveNumber, isInteger } = {}) => {
  const allowedChars = [
    "Backspace",
    "Delete",
    "ArrowLeft",
    "ArrowRight",
    "Tab",
  ];

  if (!isPositiveNumber) {
    allowedChars.push("-"); // If not positive number, allow negative sign

    if (e.key === "-") {
      if (e.target.value.includes("-") || e.target.selectionStart !== 0) {
        e.preventDefault();
      }
      return;
    }
  }

  if (!isInteger) {
    allowedChars.push("."); // If not integer, allow decimal point
  }

  if (
    /^[0-9]$/.test(e.key) ||
    allowedChars.includes(e.key) ||
    (e.key === "v" && (e.ctrlKey || e.metaKey)) || // Allow pasting
    (e.key === "c" && (e.ctrlKey || e.metaKey)) || // Allow copying
    (e.key === "a" && (e.ctrlKey || e.metaKey)) || // Allow selecting all
    (e.key === "r" && (e.ctrlKey || e.metaKey)) // Allow reloading
  ) {
    return true;
  } else {
    e.preventDefault();
  }
};

// Function for number input paste event
export const onNumberFieldPaste = (e, { isPositiveNumber, isInteger } = {}) => {
  const clipboardData = e.clipboardData || window.clipboardData;
  const pastedData = clipboardData.getData("Text");

  // if (type === "number") {
  let regex;
  if (isInteger) {
    regex = isPositiveNumber ? /^[0-9]+$/ : /^-?[0-9]+$/;
  } else {
    regex = isPositiveNumber ? /^[0-9]*\.?[0-9]*$/ : /^-?[0-9]*\.?[0-9]*$/;
  }

  if (!regex.test(pastedData)) {
    e.preventDefault();
  }
  // }
};
